export const modules = {
  billingDashboard: 'billing-dashboard',
  customActions: 'custom_actions',
  dashboard: 'developer-dashboard',
  oldReports: 'reports',
  deliveryReports: 'reports/delivery',
  developerGettingStarted: 'getting-started',
  errorReports: 'errors',
  gettingStarted: 'getting-started-dam',
  mediaExplorer: 'media-explorer',
  mediaLibrary: 'media_library',
  newErrorReports: 'reports/errors',
  monthlyValueReports: 'reports/monthly-value',
  onboardingWidget: 'welcome',
  optimizationReports: 'optimization-reports',
  optimizationCenter: 'optimization-center',
  productUpdates: 'product_updates',
  settings: 'settings',
  transformationBuilder: 'transformation_builder',
  transformationEditor: 'transformation_editor',
  transformations: 'transformations',
  transformationsCenter: 'transformations/center',
  transformationsManage: 'transformations/manage',
  transformationLog: 'transformations/transformation_log',
  upgradeOptions: 'upgrade_options',
  usageReports: 'reports/usage',
  users: 'users',
  videoPlayerReports: 'reports/video-player',
  videoHub: 'video_hub',
  videoPlayerStudio: 'video-player-studio',
  videoPlayerProfiles: 'video-player-profiles',
};
